<template>
    <div id="m-c-map-app">
        <ListFilter />
        <List v-if="isInit" />
        <Map v-if="filteredItemsCount > 0" />
    </div>
</template>

<script>
// import components used in the template
import ListFilter from "./components/ListFilter.vue";
import Map from "./components/Map.vue";
import List from "./components/List.vue";

export default {
    name: "App",
    components: {
        ListFilter,
        Map,
        List,
    },
    computed: {
        currentView() {
            return this.$store.getters.currentView;
        },
        filteredItemsCount() {
            return this.$store.getters.filteredItemsCount;
        },
        isInit() {
            return this.$store.getters.isInit;
        },
    },
    // on lifecycle hook "mounted" update app configuration in store and initialize app
    mounted() {
        this.$store.dispatch("initFilters");
        this.$store.dispatch("initProjects");
    },
};
</script>

<style lang="scss">
@import "./assets/styles/main";
</style>
